/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function DefualtImageFromJSON(json) {
    return DefualtImageFromJSONTyped(json, false);
}
export function DefualtImageFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: !exists(json, 'id') ? undefined : json['id'],
        fileUrl: !exists(json, 'file_url') ? undefined : json['file_url'],
        division: !exists(json, 'division') ? undefined : json['division']
    };
}
export function DefualtImageToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        file_url: value.fileUrl,
        division: value.division
    };
}
